import React from 'react'
import useTitle from 'utils/customHook/useTitle'
import i18n from 'simple-react-i18n'
import DevelopmentApp from 'inDevelop/components/DevelopmentApp'

const RpqsOptionsApp = () => {
    useTitle(() => [{
        title: 'RPQS',
        href: 'rpqs',
    }, {
        title: i18n.options,
        href: 'rpqs/option',
    }], [])

    return (
        <DevelopmentApp/>
    )
}

export default RpqsOptionsApp